"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EXTENSIONS = exports.AUDIO_EXTENSIONS = exports.VIDEO_EXTENSIONS = void 0;
exports.VIDEO_EXTENSIONS = {
    MPD: 'mpd',
    M3U8: 'm3u8',
    ISM: 'ism',
    ISML: 'isml',
    MP4: 'mp4',
};
exports.AUDIO_EXTENSIONS = {
    MP3: 'mp3',
    WAV: 'wav',
    M3U8: 'm3u8',
};
exports.EXTENSIONS = __assign(__assign({}, exports.VIDEO_EXTENSIONS), exports.AUDIO_EXTENSIONS);
//# sourceMappingURL=Extensions.js.map